<template>
  <div class="fixed bottom-6 right-6 z-50">
    <!-- Back to Top Button -->
    <transition name="fade">
      <button
        v-show="isVisible"
        @click="scrollToTop"
        class="group relative w-12 h-12 bg-primary-600 hover:bg-primary-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110"
        :title="scrollToTopText"
      >
        <ChevronUpIcon class="w-6 h-6 transition-transform group-hover:-translate-y-1" />
        <div class="absolute bottom-full mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          {{ scrollToTopText }}
        </div>
      </button>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { ChevronUpIcon } from '@heroicons/vue/24/outline'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const isVisible = ref(false)
const scrollToTopText = t('common.backToTop')

// Handle scroll events
const handleScroll = () => {
  isVisible.value = window.scrollY > 300
}

// Scroll to top smoothly
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>